import $ from 'jquery';

const visibleOnSelect = () => {
    $('[visible-on-select]', this).each(function (index, element) {
        let $depend = $(element);
        let $control = $(`select[name="${$depend.attr('visible-on-select')}"]`);

        //init visibility
        setVisibility($control, $depend);

        //init controller on change
        $control.on("select2:select", function () {
            setVisibility($control, $depend, false);
        });

        $control.on("select2:unselect", function () {
            setVisibility($control, $depend, true);
        });
    });
};

const setVisibility = (control, depend, isUnselect) => {
    let visibleValues = depend.attr('visible-on-value').split("||"); //parse visible values separated by '||'
    if (control.length > 1) {
        control = control.filter(":visible"); //may be depend on more selects tiwh same name, but only one is visible at the moment
    }
    if (!isUnselect && ($.inArray(control.val(), visibleValues) > -1 || (control.val() && depend.attr('visible-on-value') === "*"))) { //if match or * (any value)
        depend.show();
        $(depend).find('input, select').not("[readonly]").attr('disabled', false);
    } else {
        depend.find('select').val('').trigger('select2:select').trigger('change');
        depend.hide();
        $(depend).find('input, select').attr('disabled', true);
    }
};


export {
    visibleOnSelect
}
